class LgContextPadProvider {
	constructor(
		contextPad,
		private modeling,
	) {
		contextPad.registerProvider(this)
	}

	getContextPadEntries(element) {
		const { businessObject } = element
		return (actions: object) => {
			console.log(businessObject, actions, '')
			actions['color'] = {
				group: 'model',
				title: 'Color',
				className: 'bpmn-icon-color',
				action: {
					click: (_event, elements) => {
						const firstEl = Array.isArray(elements) ? elements[0] : elements
						let { fill } = firstEl.di
						fill = prompt('Enter color', fill)
						if (fill != undefined) {
							this.modeling.setColor(elements, {
								fill,
							})
						}
					},
				},
			}
			return actions
		}
	}
}
;(LgContextPadProvider as any).$inject = ['contextPad', 'modeling']

export const LgContextPadProviderModule = {
	__init__: ['lgContextPadProvider'],
	lgContextPadProvider: ['type', LgContextPadProvider],
}
